import i18next from "src/i18n/config";

import { AppPermission, AppPreference, Provisioning, SystemSetting } from "../types";

export const optionsSystemSettingSections: { label: string; value: SystemSetting["section"] }[] = [
    { label: i18next.t("pages:provisioningPage.options.global"), value: "Global" },
    { label: i18next.t("pages:provisioningPage.options.secure"), value: "Secure" },
    { label: i18next.t("pages:provisioningPage.options.system"), value: "System" },
];
export const optionsType: AppPreference["type"][] = ["Bool", "Float", "Int", "Long", "Set", "String"];
export const optionsAction: { label: string; value: AppPermission["action"] }[] = [
    { label: i18next.t("pages:provisioningPage.options.grant"), value: "Grant" },
    { label: i18next.t("pages:provisioningPage.options.revoke"), value: "Revoke" },
];
export const defaultProvisioning: Omit<Provisioning & { provisioningId: number | "new" }, "id" | "workspaceId"> = {
    name: "",
    provisioningId: "new",
    settings: {
        internetConfig: [],
        acceptedEula: false,
        appPermissions: [],
        appPreferences: [],
        authorizedSshKeys: [],
        automaticSetup: false,
        bootAnimationUrl: "",
        deviceManager: null,
        disabledComponents: [],
        enableAdbServer: false,
        enableBluetooth: false,
        enableMdmClient: false,
        enableSftpServer: false,
        enableSshServer: false,
        enableVncServer: false,
        enableWifi: false,
        fDroidRepos: [],
        fontScaling: 0,
        hostedApks: [],
        orientationLock: false,
        screenDensity: 0,
        screenFrequency: 0,
        screenHeight: 0,
        screenRotation: 0,
        screenWidth: 0,
        systemProperties: [],
        systemSettings: [],
        universalLicenses: [],
        wallpaperUrl: "",
    },
};
export const requiredInternetConfigMessage = i18next.t("pages:provisioningPage.requiresInternetConfiguration");
